import { extractContextsFromAction } from './utils';
export const ContextsSymbol = Symbol('@@contexts');
const pipe = functions => args => functions.reduce((acc, fn) => fn(acc), args);
export const createApplyMiddlewares = middlewares => action => pipe(middlewares)(action);
const sideEffectToMiddleware = sideEffect => action => {
  var _extractContextsFromA;
  sideEffect({
    action,
    contexts: (_extractContextsFromA = extractContextsFromAction(action)) !== null && _extractContextsFromA !== void 0 ? _extractContextsFromA : {}
  });
  return action;
};
export const createActionBus = config => {
  var _config$sideEffects;
  const middlewares = ((_config$sideEffects = config === null || config === void 0 ? void 0 : config.sideEffects) !== null && _config$sideEffects !== void 0 ? _config$sideEffects : []).map(sideEffect => sideEffectToMiddleware(sideEffect));
  const applyMiddlewares = createApplyMiddlewares(middlewares);
  const subscribers = new Map([]);
  const updateSubscriber = ([selectors, subscription]) => action => {
    if (selectors.includes(action.type)) {
      subscription(action.payload);
    }
  };
  const updateSubscibers = action => {
    subscribers.forEach((...subscriber) => updateSubscriber(subscriber)(action));
  };
  const dispatchWithContexts = contexts => (...args) => {
    const [type, payload] = args;
    const action = {
      type,
      payload: payload !== null && payload !== void 0 ? payload : {}
    };
    if (contexts) {
      // This attaches contexts from the module for analytics
      // It is delibrately excluded from types and
      // made readonly
      Object.defineProperty(action, ContextsSymbol, {
        value: contexts,
        writable: false,
        enumerable: false
      });
    }
    updateSubscibers(applyMiddlewares(action));
  };
  return {
    dispatch: dispatchWithContexts(),
    dispatchWithContexts,
    on: (...[action, callback]) => {
      subscribers.set(callback, [action]);
      return () => {
        subscribers.delete(callback);
      };
    }
  };
};
export const createActionBusWithContextsFactory = config => {
  const {
    on,
    dispatchWithContexts
  } = createActionBus(config);
  return contexts => ({
    data: module,
    reasons
  }) => ({
    on,
    dispatch: dispatchWithContexts({
      ...contexts,
      module,
      reasons
    })
  });
};